var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

(function($) {

    $('.dropdown-toggle').click(function() {
        var location = $(this).attr('href');
        window.location.href = location;
        return false;
    });

    $('.owl-carousel').owlCarousel({
        margin: 0,
        loop: true,
        center: true,
        autoWidth: true,
        dots: false,
        nav: true,
        smartSpeed :900,
        navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        responsiveClass: true,
        items: 3,
    });
    
    function ListFieldRowCount( listField, totalField ) {
        var totalRows = jQuery( listField ).find('table.gfield_list tbody tr').length;
        jQuery( totalField ).val( totalRows ).change();
    }
    
    function ListFieldRowTotal( formId, fieldId, totalFieldId ) {
        var listField = '#field_' + formId + '_' + fieldId;
        var totalField = '#input_' + formId + '_' + totalFieldId;
        new ListFieldRowCount( listField, totalField );
        jQuery( listField ).on( 'click', '.add_list_item', function() {
            ListFieldRowCount( listField, totalField );
            jQuery( listField + ' .delete_list_item' ).removeProp( 'onclick' );
        });
        jQuery( listField ).on( 'click', '.delete_list_item', function() {
            gformDeleteListItem( this, 0 );
            ListFieldRowCount( listField, totalField );
        });
    }
    
    ListFieldRowTotal( 1, 1, 2 );
    
    //ListFieldColumnTotal( form id, list field id, result - field id );
    // enable dynamic population on field that is to hold result
                
})(jQuery); 